import { DateInput, FileField, FileInput, required, TextInput, useNotify } from "react-admin";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useWatch, useFormContext } from "react-hook-form";

export default function QualityReportForm() {
  const { setValue } = useFormContext();
  const notify = useNotify();
  const [loading, setLoading] = useState(false);
  const duS = useWatch({ name: "operationRegistry.dus" });

  useEffect(() => {
    // Solo buscar si el DUS tiene al menos 3 caracteres
    if (duS && duS.trim().length >= 3) {
      setLoading(true);

      // Fetch the quality report number from the backend
      const fetchQualityReportNumber = async () => {
        try {
          const url = `${process.env.REACT_APP_API_URL}/laboratoryRegistry/quality-report/${duS}`;

          const response = await fetch(url, {
            headers: {
              "X-Correlation-Id": "foobar",
              "X-App-Id": "00e9396e-6c63-4834-8492-a1db4edc6421",
              Authorization: `Bearer ${localStorage.getItem("auth")?.toString()}`,
            },
          });

          if (response.ok) {
            const data = await response.json();

            // Llenar todos los datos del operationRegistry
            setValue("operationRegistry", data.operationRegistry);

            // Llenar la lista de verificación si existe en qualityReport.number
            // El verificationList se almacena en qualityReport.number para consistencia
            if (data.verificationList) {
              setValue("qualityReport.number", data.verificationList);
            } else {
              setValue("qualityReport.number", "");
            }
          } else {
            // Mostrar error del backend
            const errorData = await response.json();
            const errorMessage = errorData.message || "Error al buscar el DUS";
            notify(errorMessage, { type: "warning" });
            setValue("qualityReport.number", "");
          }
        } catch (error) {
          console.error("Error fetching quality report number:", error);
          const errorMessage = error instanceof Error ? error.message : String(error);
          notify(`Error al conectar con el servidor: ${errorMessage}`, { type: "error" });
          setValue("qualityReport.number", "");
        } finally {
          setLoading(false);
        }
      };

      fetchQualityReportNumber();
    } else if (duS && duS.trim().length < 3 && duS.trim().length > 0) {
      // Limpiar el campo si el DUS tiene menos de 3 caracteres
      setValue("qualityReport.number", "");
    }
  }, [duS, setValue, notify]);

  return (
    <Grid sx={{ width: "100%" }} container lg={10} lgOffset={1} spacing={2}>
      <Grid xs={12}>
        <Typography variant="h6">INFORME DE CALIDAD</Typography>
      </Grid>
      <Grid container xs={12} md={6} rowSpacing={2}>
        <Grid xs={12}>
          <TextInput
            // source="operationRegistry.report.number"
            source="qualityReport.number"
            disabled
            helperText={loading ? "Buscando..." : false}
            label="resources.laboratory_registry.fields.quality_report.fields.number"
          />
        </Grid>
        <Grid xs={12}>
          <DateInput
            source="qualityReport.date"
            helperText={false}
            label="resources.laboratory_registry.fields.quality_report.fields.date"
          />
        </Grid>
      </Grid>
      <Grid xs={12} md={6}>
        <Grid xs={12} md={4}>
          <FileInput
            source="qualityReport.file"
            helperText={false}
            label="resources.laboratory_registry.fields.quality_report.fields.file"
          >
            <FileField source="src" title="title" target="_blank" />
          </FileInput>
        </Grid>
      </Grid>
    </Grid>
  );
}
